export default "__VITE_ASSET__CZB4OIQc__";